/* eslint-disable @typescript-eslint/naming-convention */
export interface NameAndGuid {
  Name: string;
  Id: string;
}
